export default "__VITE_ASSET__CFfsMHGN__"